import React from "react";
import classes from "./addCustomerElements.module.scss";
import { Modal } from "react-bootstrap";

const partials = [
  {
    name: "Minimal",
    description:
      "suitable for light clients that can only generate classic invoices",
  },
  {
    name: "Normal",
    description:
      "the default value and is suitable for all invoice types, including advances, credit notes, and others",
  },
  {
    name: "Maximal",
    description:
      "supports the same invoice types as Normal, but includes all (rarely used) invoice data defined by the Peppol and UBL formats",
  },
];

const AddCustomerDetails = ({ toggleModal, isModalOpen, data }) => {
  const onCloseModalHandler = () => toggleModal(false);

  return (
    <Modal
      show={isModalOpen}
      onHide={onCloseModalHandler}
      dialogClassName={classes["response-modal"]}
    >
      <h4>API Details</h4>
      <div className={classes["instruction-container"]}>
        <div className={classes["instruction-content"]}>
          <div>
            <span className={classes.subtitle}>Description</span>
            <p>{data.description}</p>
            {"Complexity" in data.properties && (
              <>
                <span className={classes.subtitle}>Complexity</span>
                <ul>
                  {partials.map((partial) => {
                    return (
                      <li key={partial.name}>
                        <span>
                          <span className={classes.underline}>
                            {partial.name}:
                          </span>{" "}
                          {partial.description}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
            <span className={classes.subtitle}>Request object</span>
            <ul>
              {Object.keys(data.properties).map((key) => {
                const { title, description, type, items, properties } =
                  data.properties[key];
                return (
                  <li key={key}>
                    <span className={classes.underline}>{title}</span>
                    <ul>
                      <li>
                        type: {type} {items && `of ${items.type}s`}
                      </li>
                      <li>description: {description}</li>
                    </ul>
                    {properties && (
                      <ul style={{ marginLeft: "2rem" }}>
                        {Object.keys(properties).map((prop) => {
                          const { title, description, type, items } =
                            data.properties[key].properties[prop];
                          return (
                            <li key={Math.random().toString()}>
                              <span>{title}</span>
                              <ul>
                                <li>
                                  type: {type} {items && `of ${items.type}s`}
                                </li>
                                <li>description: {description}</li>
                              </ul>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
            {data.required.length > 0 && (
              <>
                <span className={classes.subtitle}>Required fields:</span>
                <ul>
                  {data.required.map((field) => (
                    <li key={Math.random().toString()}>{field}</li>
                  ))}
                </ul>
              </>
            )}
            {data["$d3pro"].results && (
              <>
                <span className={classes.subtitle}>Response object</span>
                <ul>
                  <li>{data["$d3pro"].results[0].description}</li>
                  <li>
                    <span className={classes.underline}>Status:</span>{" "}
                    <ul>
                      <li>
                        type: {data["$d3pro"].results[0].properties.Status.type}
                      </li>
                      <li>
                        description:{" "}
                        {
                          data["$d3pro"].results[0].properties.Status
                            .description
                        }
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span className={classes.underline}>Result:</span>{" "}
                    {/* {data["$d3pro"].results[0].properties.Result.description} */}
                    <ul>
                      <li>
                        type: {data["$d3pro"].results[0].properties.Result.type}
                      </li>
                      <li>
                        description:{" "}
                        {
                          data["$d3pro"].results[0].properties.Result
                            .description
                        }
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span className={classes.underline}>Reason:</span>{" "}
                    {/* {data["$d3pro"].results[0].properties.Reason.description} */}
                    <ul>
                      <li>
                        type: {data["$d3pro"].results[0].properties.Reason.type}
                      </li>
                      <li>
                        description:{" "}
                        {
                          data["$d3pro"].results[0].properties.Reason
                            .description
                        }
                      </li>
                    </ul>
                  </li>
                </ul>
              </>
            )}
            {/* <span className={classes.subtitle}>Registration process</span>
            <p>
              If you receive a 'Status: OK' response along with the connection
              key of the newly added company, please be aware that it may not
              appear immediately under the 'My Clients' tab. The registration
              process could take up to 24 hours to complete.
            </p> */}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddCustomerDetails;
